import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { GenericTableAnagraphAnagraph } from 'src/model/class/general classes/generic-table-anagraph-anagraph';

@Component({
    selector: 'app-load-form',
    templateUrl: './load-form.component.html',
    styleUrls: ['./load-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadFormComponent extends GenericTableAnagraphAnagraph implements OnInit {
  public showFormCtrlGrp: boolean = false;
  public showFormCtrl: boolean = false;

  constructor() { 
    super();
  }

  ngOnInit() {

  }

  OnChanges() {
    this.showFormCtrlGrp = this.CurrentObject !== undefined && this.CurrentObject !== null ? ('p1' in this.CurrentObject) : false;
    this.showFormCtrl = this.CurrentObject !== undefined && this.CurrentObject !== null ? ('onCommand' in this.CurrentObject) : false;
  }

}
